<template>
  <div>
    <div>
      <div
        class="photo-holder fs-exclude"
        :class="{'tw-rounded-xl': isOnboardingRedesign}"
      >
        <div
          v-if="
            photo &&
              !existing &&
              photoFile.type !== 'application/pdf' &&
              !isAndroidFirefoxRestriction
          "
          class="btn-crop"
          @click="openCropModal"
        >
          <b-icon icon="crop" />
        </div>
        <div
          :class="[
            'photo',
            idSize && isImageFileFormat && !isAndroidFirefoxRestriction
              ? 'id-size'
              : '',
          ]"
          :style="{
            backgroundImage: backgroundImage,
          }"
        >
          <img
            v-if="photo != '' && !loading"
            :src="photo"
            class="fs-mask"
            :style="{
              width:
                existingPhotoFileType === 'application/pdf' ? 'auto' : '100%',
            }"
          >
          <b-spinner v-if="loading" />
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-2">
        <OnboardingCTAContainer :teleport="teleportCta">
          <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
            <div v-if="isAndroid11WebView">
              <p class="sub-text">
                Please send your
                {{ backgroundType === "id" ? "ID document" : "photo" }} to our
                <a href="mailto:help@bywinona.com">email address</a> or via Intercom.
              </p>

              <b-button
                v-if="!dashboard"
                variant="info"
                pill
                block
                @click="skipUpload"
              >
                Continue
              </b-button>
            </div>

            <div
              v-else
              class="tw-flex tw-gap-2 tw-justify-center tw-flex-col"
            >
              <label
                v-if="photo == '' || isAndroidWebView"
                :for="`${componentID}-upload`"
                class="btn btn-outline-info btn-pill mobile-upload-label tw-m-0 slight-rounded"
                :class="{'tw-border-[#312849] tw-text-[#312849]': isOnboardingRedesign}"
              >
                Select Photo
              </label>

              <b-button
                v-if="captureText === 'RETAKE' && !isAndroidWebView"
                class="tw-m-0 slight-rounded"
                :class="{'tw-border-[#312849] tw-text-[#312849]': isOnboardingRedesign}"
                variant="outline-info"
                pill
                block
                :disabled="isImageUploadProcessing"
                @click="
                  photo = '';
                  photoFile = null;
                "
              >
                RETAKE
              </b-button>
              <label
                v-else-if="captureText !== 'RETAKE' && !isAndroidWebView"
                :for="`${componentID}-capture`"
                :class="{
                  'btn-info': captureText == 'TAKE PHOTO',
                  'btn-outline-info': captureText == 'RETAKE',
                }"
                class="btn btn-pill mobile-upload-label tw-m-0 slight-rounded"
                :disabled="isImageUploadProcessing"
              >
                {{ captureText }}
              </label>

              <input
                :id="`${componentID}-capture`"
                type="file"
                :accept="ACCEPTED_FILE_MIME_TYPES"
                class="mobile-upload"
                name="mobile-upload"
                capture="environment"
                @change="(e) => setPictureMobile(e, { isPhotoTaken: true })"
              >
              <input
                :id="`${componentID}-upload`"
                type="file"
                :accept="ACCEPTED_FILE_MIME_TYPES"
                class="mobile-upload"
                name="mobile-upload"
                @change="(e) => setPictureMobile(e, { isPhotoTaken: false })"
              >
              <b-button
                v-if="!dashboard && captureText == 'RETAKE'"
                variant="info"
                pill
                block
                :disabled="isImageUploadProcessing"
                class="slight-rounded"
                @click="submitAnswer"
              >
                <b-spinner
                  v-if="isImageUploadProcessing"
                  small
                />
                <span v-else>{{ submitText }}</span>
              </b-button>
            </div>
          </div>
        </OnboardingCTAContainer>

        <template v-if="isOnboardingRedesign">
          <OnboardingCertifiedSeal
            v-if="['idphoto', 'personalphoto'].includes(step)"
            class="tw-flex tw-justify-center tw-mb-4"
          />

          <IDPhotoEnsure
            v-if="page"
            :page="page"
            class="tw-mb-4 tw-mt-6"
          />
        </template>

        <div :class="{'tw-mt-6': isOnboardingRedesign}">
          <div class="tw-text-center">
            <PersonalPhotoTroubleUpload @skip="skipUpload" />
          </div>

          <div
            class="tw-text-center"
            :class="{'tw-text-[#848484]': isOnboardingRedesign}"
          >
            <OnboardingTLSSecurity v-if="showTlsSecurity" />
          </div>
        </div>
      </div>

      <template v-if="isOnboardingRedesign">
        <div
          v-show="isErrorShown"
          ref="error"
          class="tw-text-[#D24646] tw-gap-1 tw-mt-6"
          :class="{'tw-flex': isErrorShown}"
        >
          <div class="tw-size-[15px] tw-mt-1">
            <svg
              width="15"
              height="14"
              viewBox="0 0 15 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.93359 13.606C1.5332 13.606 1.18896 13.5205 0.900879 13.3496C0.612793 13.1787 0.390625 12.9468 0.234375 12.6538C0.078125 12.3657 0 12.041 0 11.6797C0 11.3379 0.090332 11.0107 0.270996 10.6982L5.63965 1.33789C5.82031 1.02051 6.05957 0.78125 6.35742 0.620117C6.65527 0.454102 6.96777 0.371094 7.29492 0.371094C7.61719 0.371094 7.92725 0.454102 8.2251 0.620117C8.52295 0.78125 8.76465 1.02051 8.9502 1.33789L14.3188 10.6982C14.4067 10.8594 14.4727 11.0229 14.5166 11.189C14.5654 11.355 14.5898 11.5186 14.5898 11.6797C14.5898 12.041 14.5117 12.3657 14.3555 12.6538C14.1992 12.9468 13.9771 13.1787 13.689 13.3496C13.4009 13.5205 13.0566 13.606 12.6562 13.606H1.93359ZM1.99951 12.3975H12.583C12.8125 12.3975 12.9932 12.3218 13.125 12.1704C13.2617 12.0239 13.3301 11.8506 13.3301 11.6504C13.3301 11.5039 13.2935 11.3647 13.2202 11.2329L7.91748 1.96777C7.84912 1.85059 7.75635 1.76514 7.63916 1.71143C7.52686 1.65283 7.41211 1.62354 7.29492 1.62354C7.17285 1.62354 7.05322 1.65283 6.93604 1.71143C6.81885 1.76514 6.72607 1.85059 6.65771 1.96777L1.3623 11.2256C1.32324 11.2939 1.29639 11.3672 1.28174 11.4453C1.26709 11.5186 1.25977 11.5869 1.25977 11.6504C1.25977 11.8506 1.32568 12.0239 1.45752 12.1704C1.58936 12.3218 1.77002 12.3975 1.99951 12.3975ZM7.29492 8.87451C6.91406 8.87451 6.71875 8.68164 6.70898 8.2959L6.61377 4.7876C6.60889 4.59229 6.66992 4.43359 6.79688 4.31152C6.92383 4.18945 7.0874 4.12842 7.2876 4.12842C7.48291 4.12842 7.64648 4.19189 7.77832 4.31885C7.91016 4.44092 7.97363 4.59961 7.96875 4.79492L7.86621 8.2959C7.85645 8.68164 7.66602 8.87451 7.29492 8.87451ZM7.29492 11.145C7.08496 11.145 6.90186 11.0742 6.74561 10.9326C6.59424 10.7861 6.51855 10.6104 6.51855 10.4053C6.51855 10.2002 6.59424 10.0269 6.74561 9.88525C6.89697 9.73877 7.08008 9.66553 7.29492 9.66553C7.50977 9.66553 7.69287 9.73633 7.84424 9.87793C8.00049 10.0195 8.07861 10.1953 8.07861 10.4053C8.07861 10.6152 8.00049 10.791 7.84424 10.9326C7.69287 11.0742 7.50977 11.145 7.29492 11.145Z"
                fill="#D24646"
              />
            </svg>
          </div>

          The file size or type is incorrect. Please upload an accepted file type (png, jpg, jpeg, pdf, heic, tiff, pjpeg) that doesn’t exceed 25 MB.
        </div>
      </template>

      <b-modal
        id="cropMobile"
        class="fs-exclude"
        size="md"
        centered
        hide-header
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        @shown="onModalShown"
      >
        <vue-croppie
          ref="croppieRefMobile"
          :enable-orientation="false"
          :enable-resize="false"
          :boundary="{ width: 300, height: backgroundType === 'id' ? 200 : 300 }"
          :viewport="{ width: 300, height: backgroundType === 'id' ? 200 : 300 }"
        />
        <b-row class="mt-3">
          <b-col
            cols="12"
            md="6"
          >
            <b-button
              pill
              block
              variant="info"
              class="slight-rounded"
              @click="cropImage"
            >
              Crop
            </b-button>
            <div class="mb-3 d-md-none"></div>
          </b-col>

          <b-col
            cols="12"
            md="6"
          >
            <b-button
              pill
              block
              variant="outline-info"
              class="slight-rounded"
              @click="closeCropModal"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// libs
import { isAndroid, isFirefox } from 'mobile-device-detect';

// assets
import pdfIcon from '@/assets/images/onboarding/pdf-icon.png';

// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import PersonalPhotoTroubleUpload from '@/components/onboarding/verification/PersonalPhotoTroubleUpload'
import OnboardingTLSSecurity from '@/components/onboarding/OnboardingTLSSecurity'
import IDPhotoEnsure from '@/components/onboarding/verification/IDPhotoEnsure';
import OnboardingCertifiedSeal from '@/components/onboarding/OnboardingCertifiedSeal';

// utils
import { ACCEPTED_FILE_MIME_TYPES } from '@/constants/files';
import { isAndroidWebView, isAndroid11WebView } from '@/utils/device';
import {
  finalizeFileForUpload,
  fileToDataUrl,
  isFileTypePdf,
  getImageFileDimensions,
  base64toFile
} from '@/utils/file';

export default {
  name: 'MobileUpload',
  components: {
    OnboardingCTAContainer,
    PersonalPhotoTroubleUpload,
    OnboardingTLSSecurity,
    OnboardingCertifiedSeal,
    IDPhotoEnsure
  },
  props: {
    idSize: {
      type: Boolean,
    },
    backgroundType: {
      type: String,
      default: 'id',
    },
    existingPhoto: {
      type: String,
      default: '',
    },
    dashboard: {
      type: Boolean,
      default: false,
    },
    existingPhotoFileType: {
      type: String,
      default: '',
    },
    teleportCta: {
      type: Boolean,
      default: true,
    },
    showTlsSecurity: {
      type: Boolean,
      default: true,
    },
    page: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      photo: '',
      photoFile: null,
      existing: false,
      orientation: 0,
      photoWidth: 0,
      photoHeight: 0,

      isErrorShown: false,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ACCEPTED_FILE_MIME_TYPES: () => ACCEPTED_FILE_MIME_TYPES,

    isAndroidWebView: () => isAndroidWebView,

    isAndroid11WebView: () => isAndroid11WebView,

    componentID() {
      return `mobile-upload-${this.backgroundType}`;
    },
    backgroundImage() {
      let imageToUse;
      switch (this.backgroundType) {
        case 'id':
          imageToUse = `url(${require('@/assets/images/id.svg')})`;
          break;
        case 'personal':
          imageToUse = `url(${require('@/assets/images/photo.jpg')})`;
          break;
      }
      return this.photo == '' ? imageToUse : '';
    },
    captureText() {
      return this.photo == '' ? 'TAKE PHOTO' : 'RETAKE';
    },
    submitText () {
      return this.photo == this.existingPhoto
        ? 'CONFIRM'
        : this.isImageUploadProcessing ? 'SUBMITTING' : 'CONFIRM';
    },
    isImageFileFormat() {
      return this.photoFile === null || this.photoFile?.type.includes('image/');
    },
    isImageUploadProcessing() {
      return this.$store.state.onboarding.isImageUploadProcessing;
    },
    // If device is on Android using Firefox and photo is > 1.04 MB
    isAndroidFirefoxRestriction() {
      return (
        isAndroid &&
        isFirefox &&
        ((this.photoFile?.size || 0) > 1065 * 1024 ||
          this.photoWidth > 4000 ||
          this.photoHeight > 4000)
      );
    },
  },
  watch: {
    existingPhoto() {
      if (this.existingPhoto) {
        this.photo = this.existingPhoto;
        this.existing = true;
      }
    },
  },
  async mounted() {
    if (!this.isAndroidWebView) {
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
      } catch (err) {
        if (err.name == 'NotAllowedError') {
          this.$emit(
            'showAlert',
            'Please enable your camera through permissions.'
          );
        }
      }
    }

    this.$emit('update:isAndroid11Webview', this.isAndroid11WebView);
  },
  beforeDestroy() {
    this.photo = '';
    this.photoFile = '';
  },
  methods: {
    openCropModal() {
      this.$bvModal.show('cropMobile');
    },
    closeCropModal() {
      this.$bvModal.hide('cropMobile');
    },
    onModalShown(){
      this.$refs.croppieRefMobile.bind({
        url: this.photo,
      });
    },
    cropImage() {
      const options = {
        format: 'jpeg',
      };
      this.$refs.croppieRefMobile.result(options, output => {
        this.photo = output;
        this.photoFile = base64toFile(output, {
          name: 'image'
        });
        this.closeCropModal();
      });
    },
    async setPictureMobile(event, { isPhotoTaken }) {
      try {
        this.existing = false;
        this.$emit('hideAlert');

        const fileToUpload = event.target.files[0];

        const { error, success } = await finalizeFileForUpload(fileToUpload);

        if (error) {
          if (this.isOnboardingRedesign) {
            this.isErrorShown = true;
            this.$refs.error?.scrollIntoView({ behavior: 'smooth' });
            window.scrollTo(0, document.body.scrollHeight + 1000);
            return
          }

          return this.$emit('showAlert', error);
        }

        this.photoFile = success;

        const isPdf = isFileTypePdf(this.photoFile);
        const dataUrl = await fileToDataUrl(this.photoFile);
        const dimensions = await getImageFileDimensions(this.photoFile);

        this.photoWidth = dimensions.width;
        this.photoHeight = dimensions.height;
        this.photo = isPdf ? pdfIcon : dataUrl;
        this.orientation = 0;
        this.isErrorShown = false

        if (this.dashboard) {
          this.$emit('submitAnswerDashboard', {
            photo: this.photo,
            file: this.photoFile,
            orientation: this.orientation,
            isPhotoTaken,
          });
        }
      } catch (err) {
        console.log(err);
        this.$emit('showAlert', err);
      }
    },
    submitAnswer() {
      if (this.photo == '') {
        this.$emit('showAlert', 'Please submit a photo.');
        return;
      }
      this.$store.commit('onboarding/SET_IS_IMAGE_UPLOAD_PROCESSING', true);
      if (this.photo == this.existingPhoto) {
        this.$emit('redirect-to-checkout');
      } else {
        this.$emit('submitAnswer', this.photoFile, this.orientation);
      }
    },
    skipUpload() {
      this.$emit('skip');
    },
  },
};
</script>

<style lang="scss" scoped>
.id-size {
  width: 250px !important;
  height: 158px !important;
}

.mobile-upload-label {
  border-radius: 24px;
  display: block;
}

.mobile-upload {
  display: none;
  opacity: 0;
}

.photo-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 250px;
  margin-bottom: 20px;
  background-color: #f2f2f2;
  position: relative;

  .btn-crop {
    padding: 0.75rem;
    background-color: white;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    color: #a783ff;
  }

  .photo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 250px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
